import { useEffect, useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, Modal, showToast } from "../../../../../../components";
import { useSelector } from "react-redux";
import { addAllLocalRestrictionApi, addLocationRAapi, getLocationBDMapi, getLocationRAapi } from "../../../../../../redux/slices/setting/settingApi";

const GeneralSettingsAddRALocationButtonModal = ({
    showAddButtonModal,
    setShowAddButtonModal,
    onSuccess
}) => {
    const [formData, setFormData, errors] = useState({
        stateName: "",
        stateCode: "",
        country: "",
        city: ""
    });
    const [loading, setLoading] = useState(false);
    const [countryId, setCountryId] = useState("")
    const [stateCodeValue, setStateCodeValue] = useState()
    const [stateId,setStateId] = useState("")
         const [statesList, setStatesList] = useState([]);
         const [stateCodeMap, setStateCodeMap] = useState({});
         const [citiesList, setCitiesList] = useState([]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };
    const { user } = useSelector((state) => state.auth);
    console.log(stateId)
    const handleSave = async () => {
        if (!formData.stateName || !formData.stateCode || !formData?.city) {
            showToast("Please fill all fields", "error");
            return;
        }
        try {
            setLoading(true);
            const response = await addLocationRAapi({
                coll: "State",
                payload: {
                    cityName: formData.city,
                    country: countryId,
                    stateName:formData?.stateName,
                    state: stateId,
                    addedBy: Number(user?.data?.uiid),
                    addedOn: new Date(),
                    stateCode: formData.stateCode,
                },
            });
            if (response?.data) {
                showToast("Location added successfully!", "success");
                setFormData({
                    stateName: "",
                    stateCode: "",
                    country: "",
                    city: ""
                });
                setShowAddButtonModal(false);
                setStateCodeValue("")
                if (onSuccess) onSuccess();
            } else {
                showToast(`${response?.field ?? "Failed to add location"}`, "error")
            }

        } catch (error) {
            console.error("Error adding location:", error);
            showToast("Failed to add Location. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };
   // console.log(formData)
    const handleClose = () => {
        setFormData({
            stateName: "",
            stateCode: "",
            country: "",
            city: ""
        });
        setShowAddButtonModal(false)
        setStateCodeValue("")
    }

    useEffect(() => {
        if (!countryId) return;
      if (statesList.includes(formData?.stateName)) { setStatesList([]); return}
        const fetchStates = async () => {
            const response = await getLocationRAapi({
                coll: "State",
                fil: JSON.stringify({
                    name: {
                        type: "SEARCH",
                        value: formData?.stateName || ""
                    },
                    country: {
                        type: "NONE",
                        value: countryId
                    }
                }),
                ret: "name stateCode _id",
                lim: 1500
            });
    
          if (response?.success) {
        const search = (formData?.stateName || "").toLowerCase();
    
        const rawStates = response?.data?.data || [];
    const selectedState = rawStates.find(item => item.name === formData.stateName);
    console.log(selectedState)
if (selectedState?._id) setStateId(selectedState._id);

        const allStates = rawStates
            .map((item) => item.name)
            .filter(Boolean);
    
        // Build lookup map
        const codeMap = {};
        rawStates.forEach((item) => {
            if (item.name && item.stateCode) {
                codeMap[item.name] = item.stateCode;
            }
        });
    
        setStateCodeMap(codeMap);
    
        const startsWith = allStates
            .filter((name) => name.toLowerCase().startsWith(search))
            .sort((a, b) => a.localeCompare(b));
    
        const contains = allStates
            .filter(
                (name) =>
                    !name.toLowerCase().startsWith(search) &&
                    name.toLowerCase().includes(search)
            )
            .sort((a, b) => a.localeCompare(b));
    
        if (!search) {
            setStatesList(allStates.sort((a, b) => a.localeCompare(b)));
        } else {
            setStatesList([...startsWith, ...contains]);
        }
    }
    
        };
    
        fetchStates();
    }, [formData?.stateName, countryId]);

    useEffect(() => {
  if (!countryId || !formData?.stateName) return;

  // Close dropdown if exact match is selected
  const isExactMatch =
    citiesList.length &&
    citiesList.some(
      (c) => c.toLowerCase() === (formData.city || "").toLowerCase()
    );

  if (isExactMatch) {
    setCitiesList([]);
    return;
  }

  const fetchCities = async () => {
    const response = await getLocationBDMapi({
      coll: "City",
      fil: JSON.stringify({
        name: { type: "SEARCH", value: formData.city || "" },
        stateName: { type: "NONE", value: formData.stateName },
        country: { type: "NONE", value: countryId },
      }),
      ret: "name",
      lim: 1500,
    });

    if (response?.success) {
      const rawCities = response.data.data || [];
      const allCities = rawCities.map((item) => item.name).filter(Boolean);

      const search = (formData.city || "").toLowerCase();

      const startsWith = allCities
        .filter((name) => name.toLowerCase().startsWith(search))
        .sort((a, b) => a.localeCompare(b));

      const contains = allCities
        .filter(
          (name) =>
            !name.toLowerCase().startsWith(search) &&
            name.toLowerCase().includes(search)
        )
        .sort((a, b) => a.localeCompare(b));

      if (!search) {
        setCitiesList(allCities.sort((a, b) => a.localeCompare(b)));
      } else {
        setCitiesList([...startsWith, ...contains]);
      }
    } else {
      setCitiesList([]);
    }
  };

  fetchCities();
}, [formData.city, formData.stateName, countryId]);

    return (

        <Modal
            isOpen={showAddButtonModal}
            onClose={handleClose}
            title="Details"
            titleColor={"primary"}
            width="max-w-xl"
        >
            <div className="grid grid-cols-2 gap-3 my-3">
                <FormFieldSet
                    type="countriesUsAndCanada"
                    title="Country"
                    placeholder="Enter Country Full Name"
                    value={formData.country}
                    onChange={(value) => {
                        handleChange("country", value.value)
                        handleChange("stateName", "")
                        handleChange("stateCode", "")
                        handleChange("city", "")
                        setCountryId(value?.id)
                    }}
                />
               <FormFieldSet
                    parentValue={{
                        country: formData?.country,
                    }}
                    title="states"
                    placeholder="Enter State Full Name"
                    value={formData.stateName}
                   onChange={(value) => {
        handleChange("stateName", value);

        const code = stateCodeMap[value];
        if (code) {
            handleChange("stateCode", code);
            setStateCodeValue(code);
        }else {
             handleChange("stateCode", "");
                  setStateCodeValue("");
                   
        }

        handleChange("city", "");
        setStateId("");
    }}
                    disabled={!formData?.country}
                    required
                      suggestionsList={statesList}
                />
                <FormFieldSet
                    title="State Code"
                    placeholder="Enter State Code"
                    parentValue={{
                        stateName: formData?.stateName,
                    }}
                    value={stateCodeValue || formData.stateCode}
                    onChange={(value) => {
                        const trimmedValue = value.slice(0, 6);

                        setStateCodeValue(trimmedValue);          
                        handleChange("stateCode", trimmedValue); 
                        handleChange("city", "");
                    }}
                    disabled={!formData.stateName && !stateCodeValue}
                    required

                />
                <FormFieldSet
                    title="City Name"
                    placeholder="Enter City Name"
                    parentValue={{
                        country: formData?.country,
                        state: formData?.stateName
                    }}
                    value={formData.city}
                    onChange={(value) => handleChange("city", value)}
                    required
                    disabled={!formData.stateCode && !stateCodeValue}
                     suggestionsList={citiesList}
                />
            </div>
            <div className="flex items-center justify-end gap-2 mt-20">
                <Button
                    variant="outlined"
                    title="Cancel"
                    size="sm"
                    onClick={handleClose}
                    disabled={loading}
                />
                <Button title="Save" size="sm" onClick={handleSave} />
            </div>
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </Modal>
    );
};

export default GeneralSettingsAddRALocationButtonModal;
